import { render, staticRenderFns } from "./UserExamNotStarted.vue?vue&type=template&id=3ce8f67a&"
import script from "./UserExamNotStarted.vue?vue&type=script&lang=ts&"
export * from "./UserExamNotStarted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
